import {CURRENT_USER_REWARDS_REQUEST, CURRENT_USER_REWARDS_RESPONSE} from '../actions/rewards.actions';

export default function reward(state = {currentUserRewards: [], availableRewards: []}, action) {
  switch (action.type) {
    case CURRENT_USER_REWARDS_REQUEST: {
      let nextState = {...state};
      nextState.currentUserRewards = [];
      return state;
    }
    case CURRENT_USER_REWARDS_RESPONSE: {
      let nextState = {...state};
      nextState.currentUserRewards = action.rewards;
      return nextState;
    }
  }
  return state;
}
